import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import "popper.js";

import "./bootstrap/util.js";
import "./bootstrap/alert.js";
import "./bootstrap/button.js";
import "./bootstrap/carousel.js";
import "./bootstrap/collapse.js";
import "./bootstrap/dropdown.js";
import "./bootstrap/modal.js";
import "./bootstrap/tab.js";
import "./bootstrap/popover.js";
import "./bootstrap/index.js";

import "./jquery/jquery-ui.js";
import "./jquery/jquery.autocomplete.js";
import "./jquery/jquery.validate.min.js";

// View Product Page
import "./jquery/jquery.easing.1.3.js";
import "./jquery/jquery.form.js";

import './jquery/jquery.datetimepicker.full.min.js';

import "./cookiePopup.js";

//import './bundle/lightcase/jquery.events.touch';
import "./bundle/lightcase/lightcase.js";
//import './bundle/matchHeight/jquery.matchHeight';
import "./bundle/priceRange/priceRange.js";
import "./bundle/slick/slick.js";

// Search
//import "./bundle/typeahead/typeaheadBundle.js";
import autoComplete from "@tarekraafat/autocomplete.js";
import DOMPurify from 'dompurify';
import "./search.js";


import Mustache from "./bundle/mustache/mustache.min.js";

//import './cookieConsent/cookieConsent';
//import './cookieConsent/cookieOptions';

import { OverlayScrollbars } from "overlayscrollbars";

import "./bundle/webp/webp.js";

import "./bundle/postcodes.min2.js";

import shave from "shave";
import { forEach } from "@splidejs/splide/src/js/utils";

import "./directionsMap.js"

// Passive event listeners
jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, {
      passive: !ns.includes("noPreventDefault"),
    });
  },
};
jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchmove", handle, {
      passive: !ns.includes("noPreventDefault"),
    });
  },
}; 



function shaveItems(){
  shave(".ellipsis", 84, { character: "..." });
  //shave(".prod-box h3 span", 58, { character: "..." });
}

function handleLoad() {
  shaveItems()
}

function handleTrueResize() {
  shaveItems()
}

let lastWidth = window.innerWidth;
let lastHeight = window.innerHeight;

function debounce(fn, delay) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(fn, delay);
  };
}

const filteredResize = debounce(() => {
  const currentWidth = window.innerWidth;
  const currentHeight = window.innerHeight;

  if (currentWidth !== lastWidth || currentHeight !== lastHeight) {
    lastWidth = currentWidth;
    lastHeight = currentHeight;
    handleTrueResize();
  }
}, 200);

// Load event
window.addEventListener('load', handleLoad);

// Resize event (filtered)
window.addEventListener('resize', filteredResize);

// Orientation change (mobile)
window.addEventListener('orientationchange', handleTrueResize);




var is_mobile = false;

var screenSize = $(window).width();



/*
var prodTitles = document.querySelectorAll(".prod-box h3 span");

prodTitles.forEach(prodTitle => {
  var titleContent = prodTitle.innerHTML;

  $(prodTitle).tooltip({
    content: titleContent,
    trigger: 'hover', // or 'click', 'focus'
    placement: 'top'  // or 'bottom', 'left', 'right', 'auto'
  });
});

*/


$(document).ready(function () {

  // Create backdrop element
    const $backdrop = $('<div class="bf-dropdown-backdrop"></div>');
    $('body').append($backdrop);
    
    // Show backdrop on hover
    $('.bf-dropdown').on('mouseenter', function() {
        $backdrop.addClass('show');
    });
    
    // Hide backdrop when leaving
    $('.bf-dropdown').on('mouseleave', function() {
        $backdrop.removeClass('show');
    });
    
    // Optional: Close dropdown when clicking backdrop
    $backdrop.on('click', function() {
        $backdrop.removeClass('show');
        $('.bf-dropdown-menu').removeClass('show');
    });


  // Mobile menu menu ================================

  var $wrapper = $("#page-wrapper"),
    $drawer = $("#nav-mobile"),
    $button = $("#nav-skip"),
    $closeBtn = $("#mobileNavClose"),
    $header = $(".site-header"),
    toggleDrawer = function () {
      $wrapper.toggleClass("active");
      $drawer.toggleClass("active");
      $button.toggleClass("toggled");
      $header.toggleClass("active");
    };

  $("#page_wrapper > .main-content").on("click", function () {
    if ($wrapper.hasClass("active")) toggleDrawer();
  });
  $button.on("click", function (e) {
    e.preventDefault();
    toggleDrawer();
  });
  $closeBtn.on("click", function (e) {
    e.preventDefault();
    toggleDrawer();
  });


  var width = $(window).width();
  $(window).on("resize", function () {
    if ($(window).width() !== width) {
      if ($wrapper.hasClass("active")) toggleDrawer();
      width = $(window).width();
    }
  });

  $(document).on("click", function (e) {
    if (
      $(e.target).hasClass("page-wrapper") &&
      $(e.target).hasClass("active")
    ) {
      toggleDrawer();
    }
  });

  var header = document.querySelector(".site-header");

  if (header) {
    var fixHeader = function () {
      // Find out height of header element
      var headerHeight = header.offsetHeight;

      // Set --header-height custom property
      document.documentElement.style.setProperty(
        "--header-height",
        headerHeight + "px"
      );

      // Get scroll position
      let scroll = window.scrollY;

      // Toggle class
      if (scroll > 150) {
        header.classList.add("scrolling");
      } else {
        header.classList.remove("scrolling");

        // Find out height of header element
        var headerHeight = header.offsetHeight;

        // Set --header-height custom property
        document.documentElement.style.setProperty(
          "--header-height",
          headerHeight + "px"
        );
      }
    };

    // Run on scroll/load/resize
    window.addEventListener("scroll", fixHeader, false);
    window.addEventListener("load", fixHeader, false);
    window.addEventListener("resize", fixHeader, false);
  }

  // Main menu drop downs on hover ====================

  // Hover for Bootstrap Menus

  // * must add class '.dropdown-hover' to the data-toggle's parent

  /*
        $('.dropdown-hover').hover(function(){
            $(this).children('[data-toggle="dropdown"]').click();
        }, function(){
            $(this).children('[data-toggle="dropdown"]').click();
        });
        */

  $(".dropdown")
    .mouseover(function () {
      $(this).addClass("show").attr("aria-expanded", "true");
      $(this).find(".dropdown-menu").addClass("show");
    })
    .mouseout(function () {
      $(this).removeClass("show").attr("aria-expanded", "false");
      $(this).find(".dropdown-menu").removeClass("show");
    });

  // MatchHeight =====================================
  //$('.main-nav .nav-link').matchHeight({ byRow: false });
  //$('.prod-box h3').matchHeight({ byRow: true });
  //$('.checkout-payments .holder').matchHeight({ byRow: true });




// Adjust height of tt-menu depending on available space
/*
function updateDropdownHeight() {
  const viewportHeight = window.visualViewport?.height || window.innerHeight;

  const headerHeight = parseFloat(
    getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height')
  ) || 0;

  const offset = 48; // your fixed extra spacing

  const maxHeight = viewportHeight - headerHeight;

  document.querySelector('.tt-menu').style.maxHeight = `${maxHeight}px`;
}

window.visualViewport?.addEventListener('resize', updateDropdownHeight);
window.addEventListener('focus', updateDropdownHeight, true);
window.addEventListener('load', updateDropdownHeight);

*/

/*

// Close keyboard when scrolling .tt-menu
const input = document.querySelector('#hdsearch');

let startY = 0;
let isTouching = false;
let preventClose = false;

// Use event delegation in case tt-menu is re-rendered
document.addEventListener('touchstart', (e) => {
  const menu = e.target.closest('.tt-menu');
  if (!menu) return;

  isTouching = true;
  startY = e.touches[0].clientY;
});

document.addEventListener('touchmove', (e) => {
  const menu = e.target.closest('.tt-menu');
  if (!menu || !isTouching) return;

  const currentY = e.touches[0].clientY;
  const diff = Math.abs(currentY - startY);

  if (diff > 10) {
    preventClose = true;
    input.blur();

    // allow Typeahead to close normally again after a moment
    setTimeout(() => {
      preventClose = false;
    }, 200);

    isTouching = false;
  }
});

document.addEventListener('touchend', () => {
  isTouching = false;
});

// Keep search open when blur is triggered by scroll
$(input).on('typeahead:beforeclose', function () {
  if (preventClose) {
    return false;
  }
});

*/


  // Animate Carousel Items ==========================

  jQuery(function ($) {
    var $myCarousel = $("#homepage-carousel");

    // Initialize carousel
    $myCarousel.carousel();

    function doAnimations(elems) {
      var animEndEv = "webkitAnimationEnd animationend";

      elems.each(function () {
        var $this = $(this),
          $animationType = $this.data("animation");

        // Add animate.css classes to
        // the elements to be animated
        // Remove animate.css classes
        // once the animation event has ended
        $this.addClass($animationType).one(animEndEv, function () {
          $this.removeClass($animationType);
        });
      });
    }

    // Select the elements to be animated
    // in the first slide on page load
    var $firstAnimatingElems = $myCarousel
      .find(".slide-bg:first")
      .find('[data-animation ^= "animated"]');

    // Apply the animation using our function
    doAnimations($firstAnimatingElems);

    // Pause the carousel
    $myCarousel.carousel("pause");

    // Attach our doAnimations() function to the
    // carousel's slide.bs.carousel event
    $myCarousel.on("slide.bs.carousel", function (e) {
      // Select the elements to be animated inside the active slide
      var $animatingElems = $(e.relatedTarget).find(
        "[data-animation ^= 'animated']"
      );
      doAnimations($animatingElems);
    });
  });

  // Homepage Filter =================================

  var cat_text = $(".cat-select span").text();
  var type_text = $(".type-select span").text();
  var brand_text = $(".brand-select span").text();
  $("#searchprodbutton").attr("disabled", true);

  $("#filter_reset_home").click(function (e) {
    e.preventDefault();
    $("#searchprodbutton").addClass("disabled");
    $("#searchprodbutton").attr("disabled", true);

    $(".type-select").addClass("disabled");
    $(".type-select").removeClass("picked");
    $(".type-select span").html("Select Type");

    $(".brand-select").addClass("disabled");
    $(".brand-select").removeClass("picked");
    $(".brand-select span").html("Select Brand");

    $(".cat-option").removeClass("selected");
    $(".cat-select").removeClass("picked");
    $(".cat-select span").html("Select a Category");

    $("#searchprodbutton").removeClass("btn-glow");

    $("#hmmasterId").val("");
    $("#hmcatId").val("");
    $("#hmbrandId").val("");
    $("#brandprods").val("");
    $("#masterprods").val("");
    $("#catprods").val("");

    $("#searchprodbutton").html("<span>Search</span>");

    // price range slider
    $("#slider")
      .slider({
        min: 0,
        max: 5000,
        range: true,
        values: [0, 5000],
        step: 500,
        slide: function (event, ui) {
          $("#pricefrom").val(ui.values[0]);
          $("#priceto").val(ui.values[1]);
        },
      })
      .slider("pips", { rest: "label", step: 2 })
      .slider("float");
  });

  // Close tab
  function closeActiveTab() {
    $(".tab-pane.active").removeClass("active");
    $(".filter-holder .nav-link.active").removeClass("active");
    $(".filter-fade").removeClass("active");
    $(".carousel-filter").removeClass("active");
    $(".slide-bg").removeClass("blur");
  }

  $(".cat-option").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("selected");
    $("#searchprodbutton").removeClass("btn-glow");
    if ($(this).hasClass("selected")) {
      var masterid = $(this).data("masterid");
      console.log("MasterId: " + masterid);
      $("#hmmasterId").val(masterid);
      $("#hmcatId").val("");
      $("#hmbrandId").val("");
      $(".type-select").removeClass("disabled");
      $("#searchprodbutton").removeClass("disabled");
      $("#searchprodbutton").attr("disabled", false);
    } else {
      $("#searchprodbutton").addClass("disabled");
      $("#searchprodbutton").attr("disabled", true);
      $(".type-select").addClass("disabled");
      $("#hmmasterId").val("");
      $("#hmcatId").val("");
      $("#hmbrandId").val("");
      $("#brandprods").val("");
      $("#masterprods").val("");
      $("#catprods").val("");
      $("#searchprodbutton").html("<span>Search</span>");
      // price range slider
      $("#slider")
        .slider({
          min: 0,
          max: 5000,
          range: true,
          values: [0, 5000],
          step: 500,
          slide: function (event, ui) {
            $("#pricefrom").val(ui.values[0]);
            $("#priceto").val(ui.values[1]);
          },
        })
        .slider("pips", { rest: "label", step: 2 })
        .slider("float");
    }

    if ($(".cat-option.selected").length) {
      $(".cat-option").not(this).removeClass("selected");
      $(".cat-select span").empty();
    } else {
      // remove tick
      $(".cat-select").toggleClass("picked");

      // reset type selection
      $(".type-option").each(function () {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        }
      });
      $(".type-select").addClass("disabled");
      $(".type-select").removeClass("picked");

      // reset brand selection
      $(".brand-option").each(function () {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        }
      });
      $(".brand-select").addClass("disabled");
      $(".brand-select").removeClass("picked");

      // reset select text
      $(".cat-select span").text(cat_text);
      $(".type-select span").text(type_text);
      $(".brand-select span").text(brand_text);
    }

    $(".cat-option").each(function () {
      if ($(this).hasClass("selected")) {
        // add tick to select to show an option has been selected
        $(".cat-select").addClass("picked");

        $("#v-pills-type").load(
          "/ajax/home_loadtypes?masterid=" + masterid,
          function () {
            // remove disabled state of next option
            $(".type-select").removeClass("disabled");
            $("#hmbrandId").val("");
            $("#hmcatId").val("");
          }
        );

        // remove active state from current select
        $(".cat-select").removeClass("active");

        // add active state to next select
        $(".type-select").addClass("active");

        // open next menu
        $("#v-pills-type").tab("show");

        // close current menu
        $("#v-pills-cat").tab("dispose").removeClass("active");

        // replace text with selected
        var str = $(".cat-option.selected h4").text();
        $(".cat-select span").empty();
        $(".cat-select span").text(str);

        // reset type options
        $(".type-option").removeClass("selected");
        $(".type-select").removeClass("picked");
        $(".type-select span").text("Select Type");

        // reset brand options
        $(".brand-option").removeClass("selected");
        $(".brand-select").removeClass("picked");
        $(".brand-select span").text("Select Brand");
      }
    });
  });


     $('.dept-option').click(function(e){
        e.preventDefault();
        $(this).toggleClass('selected');
        $("#searchprodbutton").removeClass('btn-glow');
        if($(this).hasClass('selected')){
            var masterid = $(this).data('masterid');
            console.log('MasterId: '+masterid);
            $("#hmmasterId").val('');
            $("#hmcatId").val('');
            $("#hmbrandId").val('');
            $('.type-select').removeClass('disabled');
            $("#searchprodbutton").removeClass('disabled');
            $("#searchprodbutton").attr("disabled", false);

        }else{
            $("#searchprodbutton").addClass('disabled');
            $("#searchprodbutton").attr("disabled", true);
            $('.type-select').addClass('disabled');
            $("#hmmasterId").val('');
            $("#hmcatId").val('');
            $("#hmbrandId").val('');
            $("#brandprods").val('');
            $("#masterprods").val('');
            $("#catprods").val('');
            $("#searchprodbutton").html("<span>Search</span>");
            // price range slider
            $("#slider").slider({ min: 0, max: 5000, range: true, values: [0, 5000], step: 500
                , slide: function( event, ui ) {
                $( "#pricefrom" ).val(ui.values[0]);
                $( "#priceto" ).val(ui.values[1]);}
             }).slider("pips", {rest: "label", step: 2}).slider("float");
        }


        if($('.cat-option.selected').length){
            $('.cat-option').not(this).removeClass('selected'); 
            $('.cat-select span').empty();                              
        }

        else{
            // remove tick
            $('.cat-select').toggleClass('picked');

            // reset type selection                    
            $('.type-option').each(function() {
                if ($(this).hasClass('selected')) {
                    $(this).removeClass('selected'); 
                }
            });                                
            $('.type-select').addClass('disabled');
            $('.type-select').removeClass('picked');

            // reset brand selection 
            $('.brand-option').each(function() {
                if ($(this).hasClass('selected')) {
                    $(this).removeClass('selected'); 
                }
            });  
            $('.brand-select').addClass('disabled');                                 
            $('.brand-select').removeClass('picked'); 

            // reset select text
            $('.cat-select span').text(cat_text);
            $('.type-select span').text(type_text);
            $('.brand-select span').text(brand_text); 
        }         

        $('.dept-option').each(function() {                                             

            if ($(this).hasClass('selected')) {

                // add tick to select to show an option has been selected                
                $('.cat-select').addClass('picked');
                var ajurl = "/ajax/"+masterid;
                $('#v-pills-type').load(""+ajurl, function(){
                    // remove disabled state of next option
                    $('.type-select').removeClass('disabled');    
                    $("#hmbrandId").val('');
                    $("#hmcatId").val('');
                });    

               
                
                
                // remove active state from current select
                $('.cat-select').removeClass('active');

                // add active state to next select
                $('.type-select').addClass('active');

                // open next menu
                $('#v-pills-type').tab('show');                 

                // close current menu
                $('#v-pills-cat').tab('dispose').removeClass('active');

                // replace text with selected                                
                var str = $('.dept-option.selected h4').text();
                $('.cat-select span').empty(); 
                $('.cat-select span').text(str);

                // reset type options
                $('.type-option').removeClass('selected');
                $('.type-select').removeClass('picked'); 
                $('.type-select span').text('Select Type'); 
                
                // reset brand options
                $('.brand-option').removeClass('selected');
                $('.brand-select').removeClass('picked'); 
                $('.brand-select span').text('Select Brand');                
                
            }            
        });

    });



  $(".type-option").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("selected");
    $("#v-pills-cat").tab("dispose");

    var catid = $(this).data("catid");
    console.log("catid: " + catid);

    $("#hmcatId").val(catid);
    masterid = $("#hmmasterId").val();

    if ($(".type-option.selected").length) {
      $(".type-option").not(this).removeClass("selected");
      $(".type-select span").empty();
    } else {
      // remove tick
      $(".type-select").removeClass("picked");

      // reset brand selection
      $(".brand-option").each(function () {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        }
      });
      $(".brand-select").addClass("disabled");
      $(".brand-select").removeClass("picked");

      // reset select text
      $(".type-select span").text(type_text);
      $(".brand-select span").text(brand_text);
      $("#pricefrom").val("0");
      $("#priceto").val("20000");
    }

    $(".type-option").each(function () {
      if ($(this).hasClass("selected")) {
        // add tick to select to show an option has been selected
        $(".type-select").addClass("picked");

        $("#v-pills-brand").load(
          "/ajax/home_loadbrand?masterid=" + masterid + "&catid=" + catid,
          function () {
            // remove disabled state of next option
            $(".type-select").removeClass("disabled");
          }
        );

        // remove disabled state of next option
        $(".brand-select").removeClass("disabled");

        // remove active state from current select
        $(".type-select").removeClass("active");

        // add active state to next select
        $(".brand-select").addClass("active");

        // open next menu
        $("#v-pills-brand").tab("show");

        // close current menu
        $("#v-pills-type").tab("dispose").removeClass("active");

        // replace text with selected
        var str = $(".type-option.selected h4").text();
        $(".type-select span").text(str);

        // reset brand options
        $(".brand-option").removeClass("selected");
        $(".brand-select").removeClass("picked");
        $(".brand-select span").text("Select Brand");
      }
    });
  });

  $(".brand-option").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("selected");
    $("#v-pills-type").tab("dispose");

    var brandid = $(this).data("brandid");
    console.log("brandid: " + brandid);

    $("#hmbrandId").val(brandid);
    catid = $("#hmcatId").val();
    masterid = $("#hmmasterId").val();

    // closes menu and background effects once option is selected
    $(".tab-pane.active").removeClass("active");
    $(".filter-holder .nav-link.active").removeClass("active");
    $(".filter-fade").removeClass("active");
    $(".carousel-filter").removeClass("active");
    $(".slide-bg").removeClass("blur");

    if ($(".brand-option.selected").length) {
      $(".brand-option").not(this).removeClass("selected");
      $(".brand-select span").empty();
    } else {
      // remove tick
      $(".brand-select").removeClass("picked");

      // reset select text
      $(".brand-select span").text(brand_text);
    }

    $(".brand-option").each(function () {
      if ($(this).hasClass("selected")) {
        // add tick to select to show an option has been selected
        $(".brand-select").addClass("picked");

        // replace text with selected
        var str = $(".brand-option.selected h4").text();
        $(".brand-select span").text(str);
      }
    });
  });

  // price range slider
  $("#slider")
    .slider({
      min: 0,
      max: 5000,
      range: true,
      values: [0, 5000],
      step: 500,
      slide: function (event, ui) {
        $("#pricefrom").val(ui.values[0]);
        $("#priceto").val(ui.values[1]);
        $.post(
          "ajax/getprodno",
          {
            masterId: $("#hmmasterId").val(),
            catId: $("#hmcatId").val(),
            branId: $("#hmbrandId").val(),
            pricefrom: $("#pricefrom").val(),
            priceto: $("#priceto").val(),
          },
          function (data) {
            $("#searchprodbutton").html(
              "<span>Search " + data + " Products</span>"
            );
          }
        );
      },
    })
    .slider("pips", { rest: "label", step: 2 })
    .slider("float");

  // add carousel backdrop when tab is open

  $('a[data-toggle="pill"]').on("shown.bs.tab", function (e) {
    $(".filter-fade").addClass("active");
    $(".carousel-filter").addClass("active");
    $(".slide-bg").addClass("blur");
  });

  // Close Buttons
  $(document).on("click", ".close-tab", function (e) {
    closeActiveTab();
  });

  // product gallery ------------------------

  // handles the carousel thumbnails
  $("[id^=carousel-selector-]").click(function () {
    var id_selector = $(this).attr("id");
    var id = id_selector.substr(id_selector.length - 1);
    id = parseInt(id);
    $("#prodSlide").carousel(id);
    $("[id^=carousel-selector-]").removeClass("selected");
    $(this).addClass("selected");
  });

  // when the carousel slides, auto update
  $("#prodSlide").on("slide.bs.carousel", function (e) {
    var id = $(".item.active").data("slide-number");
    id = parseInt(id);
    $("[id^=carousel-selector-]").removeClass("selected");
    $("[id=carousel-selector-" + id + "]").addClass("selected");
  });

  $("a[data-rel^=lightcase]").lightcase({
    swipe: true,
    maxWidth: 1920,
    maxHeight: 1000,
    shrinkFactor: 0.9,
    transition: "elastic",
  });

  // Quantity plus/minus
  //$('.count').prop('disabled', true);

  $(document).on("click", ".plus", function () {
    $(".count").val(parseInt($(".count").val()) + 1);
  });

  $(document).on("click", ".minus", function () {
    $(".count").val(parseInt($(".count").val()) - 1);
    if ($(".count").val() == 0) {
      $(".count").val(1);
    }
  });

  // account menu mobile navigation
  $("#account_menu_select").change(function (e) {
    e.preventDefault();
    window.location = $(this).val();
  });

  //Recently viewed products
  $("#recent-view").click(function (e) {
    e.preventDefault();
    var $this = $(this);
    var isShown = $this.attr("data-is-shown");
    if (isShown === "false") {
      //Show it
      $("#bottom-bar").addClass("open");
      $this.attr("data-is-shown", "true");
      $this.addClass("recent-view-close");
    } else {
      //Hide it
      hideRecentList();
    }
  });

  //When users leaves the recent product list, close it.
  $("#bottom-bar").mouseleave(function () {
    var isShown = $("#recent-view").attr("data-is-shown");
    if (isShown === "true") {
      hideRecentList();
    }
  });

  function hideRecentList() {
    $("#recent-view").attr("data-is-shown", "false");
    $("#bottom-bar").toggleClass("open");
    $("#recent-view").removeClass("recent-view-close");
  }

  // slick carousel
  $(".recent-prods").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  });

  $(".product-thumbs").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        },
      },
    ],
  });

  $(".sale-pages-carousel").slick({
    lazyLoad: "ondemand",
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".category-carousel").slick({
    lazyLoad: "ondemand",
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".prod-message-carousel").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
  });
});

// close active tab when clicking on anything but the tab and it's children
$(document).mouseup(function (e) {
  var container = $("#homepage-carousel .tab-pane.active");

  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".filter-holder .nav-link.active").removeClass("active");
    $(".filter-fade").removeClass("active");
    $(".carousel-filter").removeClass("active");
    $(".slide-bg").removeClass("blur");
    container.removeClass("active");
  }
});

// Add custom scroll bar to the filters when needed
var filterTab = document.querySelector(".filter-tab-pane");

if (filterTab) {
  OverlayScrollbars(document.querySelector(".filter-tab-pane"), {
    overflow: {
      x: "hidden",
    },
    scrollbars: {
      visibility: "auto",
      autoHide: "leave",
    },
  });
}

const prodFilterCol = document.querySelector(".filter-col");

if (prodFilterCol) {
  // Resize sticky filter button when it becomes sticky
  window.onscroll = function () {
    //const el = document.querySelector(".filter-col")

    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
      { threshold: [1] }
    );

    observer.observe(prodFilterCol);
  };
}

// Add custom scroll bar to the filters when needed
var filterCollapse = document.querySelector(".filter-collapse");

if (filterCollapse) {
  OverlayScrollbars(document.querySelector(".filter-collapse"), {
    overflow: {
      x: "hidden",
    },
    scrollbars: {
      visibility: "auto",
      autoHide: "never",
    },
  });
}

$(".validateForm").validate();

const filterToggle = document.querySelector(".filter-toggle");

if (filterToggle) {
  let scroll = window.scrollY;

  filterToggle.addEventListener(
    "click",
    function () {
      var scroll = window.scrollY;

      if (scroll > 100) {
        //var scroll = window.scrollY;
        //console.log(scroll);
      } else {
        //var scroll = window.scrollY;
        window.scroll(0, 300);
        //console.log("scroll is less than 100");
        //var scroll = window.scrollY;
        //console.log(scroll);
      }
    },
    false
  );
}
